import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import KakaoLogin from './pages/KakaoLogin';
import Profile from './pages/ModifyProfile';
import Home from './pages/Home';
import DiaryCalendar from './pages/DiaryCalendar';
import DiaryWrite from './pages/DiaryWrite';
import DiaryDetail from './pages/DiaryDetail';
import DiaryEdit from './pages/DiaryEdit';
import NotFound from './pages/NotFound';
import { ToastProvider } from './components/Toast';

function App() {
    return (
        <ToastProvider>
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/login" element={<KakaoLogin />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/home" element={<Home />} />
                        <Route path="/diary" element={<DiaryCalendar />} />
                        {/* 정적 세그먼트(new)를 :diaryId보다 앞에 — 매칭 의도를 명시 */}
                        <Route path="/diary/new" element={<DiaryWrite />} />
                        <Route path="/diary/:diaryId" element={<DiaryDetail />} />
                        <Route path="/diary/:diaryId/edit" element={<DiaryEdit />} />
                        <Route path="/" element={<Navigate to="/home" replace />} />
                        {/* catch-all — 어느 라우트에도 안 걸리는 경로는 404 안내 */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>
            </Router>
        </ToastProvider>
    );
}

export default App;
